module.exports = __webpack_public_path__ + "static/media/bacteria.1cf80032.svg";